



















































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderDeliveryDone from '@/components/order/mixins/OrderDeliveryDone';

import { Component, Mixins, Ref } from 'vue-property-decorator';
import {OrderStatusType, PutOrderOptionChangeStatusRequest} from 'supporter';
import {i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/commonUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable}
})
export default class OrderListDeliveryDone extends Mixins(OrderDeliveryDone, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom')
  private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private request: any = {
    params: {}
  };
  public ifExchange: boolean = false;
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private memberGroupData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };
  private theSearchTypeArr: any = [
    {value: 'STATE_CHANGE_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_DELIVERY_DONE_STATE_CHANGE_YMDT'},
    {value: 'ORDER_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_DELIVERY_DONE_ORDER_YMDT'}
  ];
  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };

  private created(): void {
    this.exchangeHelpData = i18nObjectByKey(this, this.exchangeHelpData, 'title');
    this.memberGroupData = i18nObjectByKey(this, this.memberGroupData, 'title');
  }
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on('click', '.changeStatusEach', $.proxy(this.changeStatusBtnClick, this));
    $('body').on(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
  }
  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').off('click', '.changeStatusEach', $.proxy(this.changeStatusBtnClick, this));
    $('body').off(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
  }
  private changeStatusBtnClick(e: any): void {
    if (!confirm(this.$t('ORDER_LIST_GRIDS_CHANGE_STATUS_CONFIRM') as string)) {
      return;
    }
    let theOption: any[] = [];
    let no: any = $(e.target).attr('orderProductOptionNo');
    theOption.push(this.getRowItems(Number(no)));
    let requestOp: any = theOption.map((item: any) => {
      return {deliveryCompanyType: item.deliveryCompanyType, invoiceNo: item.invoiceNo, mallNo: item.mallNo, orderOptionNo: item.orderProductOptionNo};
    });
    let request: PutOrderOptionChangeStatusRequest = {
      data: {
        orderStatusType: 'PRODUCT_PREPARE',
        options: requestOp
      }
    };
    this.$api.putOrderOptionChangeStatus(request).then(() => {
      this.search(1, (this.$refs.gridBottom as any).pageSize);
    });
  }
  private getRowItems(rowKey: any): any {
    return (this.$refs.gridBottom as any).getRowItems(rowKey);
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }

  private initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_delivered_';
  }
  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'DELIVERY_DONE';
    this.request.params.partnerNo = Number(e.partnerNo);

    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsDeliveryGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'deliveryOrderGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = [
            'shippingNo',
            'deliveryMemo',
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'remoteDeliveryAmt',
            'orderRegisterType',
            'reservation',
            'memberGroupInfoJson',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let midRow = ['mallNo', 'payType', 'platformType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }
  private handleCancel(): void {}
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'DELIVERY_DONE';
    this.request.params.page = page;
    this.request.params.size = size || this.initPageSize;
    $('#loading').show();
    this.$api
      .getOrderOptionsDeliveryGrid(this.request)
      .then((res) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'deliveryOrderGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = [
            'shippingNo',
            'deliveryMemo',
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'deliveryAmtInAdvanceYn',
            'remoteDeliveryAmt',
            'orderRegisterType',
            'reservation',
            'memberGroupInfoJson',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let midRow = ['mallNo', 'payType', 'platformType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }

  private changeStatus(type: OrderStatusType): void {
    if (this.getCheckedRowKeys().length === 0) {
      if (type === 'PAY_DONE') {
        alert(this.$t('ORDER_LIST_GRIDS_DEPOSIT_NOT_CHECK_ROW_ALERT'));
      } else {
        alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      }
      return;
    }

    if (!confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE') as string)) {
      return;
    }

    const checkList: any = this.getCheckedRows();
    this.changeStatusProc(type, checkList, true, this.$refs.gridBottom, 'PRODUCT_PREPARE', this.search);
  }
  private getCheckedRowKeys(): any {
    return (this.$refs.gridBottom as any).getCheckedRowKeys();
  }
  private getCheckedRows(): any {
    return (this.$refs.gridBottom as any).getCheckedRows();
  }
}
